let lockCount = 0;
let savedScrollY = 0;
let savedBodyStyles = null;

const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

const saveBodyStyles = (body) => ({
  position: body.style.position,
  top: body.style.top,
  left: body.style.left,
  right: body.style.right,
  width: body.style.width,
  overflow: body.style.overflow,
  overflowX: body.style.overflowX,
  overflowY: body.style.overflowY,
  paddingRight: body.style.paddingRight,
});

const restoreBodyStyles = (body) => {
  if (!savedBodyStyles) {
    return;
  }

  body.style.position = savedBodyStyles.position;
  body.style.top = savedBodyStyles.top;
  body.style.left = savedBodyStyles.left;
  body.style.right = savedBodyStyles.right;
  body.style.width = savedBodyStyles.width;
  body.style.overflow = savedBodyStyles.overflow;
  body.style.overflowX = savedBodyStyles.overflowX;
  body.style.overflowY = savedBodyStyles.overflowY;
  body.style.paddingRight = savedBodyStyles.paddingRight;

  savedBodyStyles = null;
};

export function disableBodyScroll(_targetElement) {
  if (typeof window === 'undefined') {
    return;
  }

  if (lockCount === 0) {
    const body = document.body;
    if (!body) {
      return;
    }

    savedScrollY = window.scrollY || window.pageYOffset || 0;
    savedBodyStyles = saveBodyStyles(body);

    body.style.position = 'fixed';
    body.style.top = `-${savedScrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    body.style.overflowX = 'hidden';
    body.style.overflowY = 'hidden';

    const scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  lockCount += 1;
}

export function enableBodyScroll(_targetElement) {
  if (typeof window === 'undefined' || lockCount === 0) {
    return;
  }

  lockCount -= 1;
  if (lockCount > 0) {
    return;
  }

  const body = document.body;
  if (body) {
    restoreBodyStyles(body);
  }

  window.scrollTo(0, savedScrollY);
}

export function clearAllBodyScrollLocks() {
  if (typeof window === 'undefined' || lockCount === 0) {
    return;
  }

  lockCount = 1;
  enableBodyScroll();
}
